export default __webpack_public_path__ + "static/media/IC00040-edit.11c0d6d1.svg";